<template>
  <div>
    <div class="query-bar">
      <el-form ref="query" :model="query" label-width="100px" inline>
        <el-form-item prop="isComplete" label="显示已完成">
          <el-checkbox v-model="query.isComplete" size="small" />
        </el-form-item>
        <el-form-item label="送货单号">
          <el-input v-model="query.fCkBillNo" size="small" style="width:150px;" clearable />
        </el-form-item>
        <el-form-item label="批号">
          <el-input v-model="query.fBatchNo" size="small" style="width:150px;" clearable />
        </el-form-item>
        <el-form-item label="产品">
          <el-select-table
            v-model="query.fICItemID"
            :label.sync="fName"

            url="ICItemManage/ICItem/ChoiceICItemEntry"
            label-field="fName"
            value-field="ficItemID"
            size="small"
            :extra-param="{ prohibit: false }"
            panel-width="500px"
            :columns="[
              { prop: 'fNumber', label: '编码' },
              { prop: 'fName', label: '名称' },
              { prop: 'fModel', label: '规格' },
              { prop: 'fUnit', label: '单位' },
            ]"
          />
        </el-form-item>
      </el-form>
      <el-button type="primary" size="small" @click="refresh">查询</el-button>
    </div>
    <el-table v-loading="loading" :data="tableData" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="42" />
      <el-table-column prop="fOrderNo" label="送货单号" width="130" />
      <el-table-column prop="fNumber" label="产品编号" />
      <el-table-column prop="ficItem" label="产品名称" />
      <el-table-column prop="fModel" label="规格型号" />
      <el-table-column prop="fUnit" label="单位" width="50" />
      <el-table-column prop="fBatchNo" label="生产批号" width="100" />
      <el-table-column prop="fDate_Sc" label="生产日期" :formatter="dateFormat" width="100" />
      <el-table-column prop="fRetroactiveNo" label="追溯号" />
      <el-table-column prop="inventoryQty" label="库存数" width="80" />
      <el-table-column label="销售数量" width="80">
        <template slot-scope="scope">
          <el-input-currency v-model="scope.row.fQty" :scale="0" size="small" :min="null" />
        </template>
      </el-table-column>
      <!-- <el-table-column label="配货数">
        <template slot-scope="scope">
          <el-input-currency v-model="scope.row.fPhQty" :scale="0" style="width:70px" />
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination
      style="margin-top:10px"
      :current-page.sync="query.pageIndex"
      :page-size.sync="query.pageSize"
      :page-sizes="[10, 20, 50, 100, 500]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageRecordTotal"
      @size-change="refresh"
      @current-change="refresh"
    />
  </div>
</template>
<script>
import moment from 'moment'

export default {
  model: {
    prop: 'value',
    event: 'changeVal'
  },
  props: {
    value: Array,
    fEntryID: Number,
    visible: Boolean
  },
  data() {
    return {
      query: {
        isComplete: null,
        fCkBillNo: null,
        fBatchNo: null,
        fICItemID: null,

        pageIndex: 1,
        pageSize: 10
      },
      pageRecordTotal: 0,
      fName: '',

      tableData: [],
      loading: false
    }
  },
  watch: {
    visible: function(v) {
      if (v) {
        this.refresh()
      }
    }
  },
  mounted: function() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost('SalesRecordManage/SalesRecord/SalesInventory', this.query).then((res) => {
        if (!res.isSuccess) {
          this.$message.error(res.message)
          return
        }
        this.tableData = res.datalist.dataEntry
        this.pageRecordTotal = res.datalist.total
      })
        .finally(() => this.loading = false)
    },
    handleSelectionChange(val) {
      this.$emit('changeVal', val)
    },
    dateFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD')
    }
  }
}
</script>
